<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconChromeLogo_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M20.604 6.903a.164.164 0 0 1-.141.247h-8.04a4.87 4.87 0 0 0-5.139 3.634.164.164 0 0 1-.3.041L4.169 5.95a.164.164 0 0 1 .014-.184A9.956 9.956 0 0 1 12 2.001a9.992 9.992 0 0 1 8.604 4.902ZM12 15.738A3.741 3.741 0 0 1 8.263 12 3.741 3.741 0 0 1 12 8.263a3.741 3.741 0 0 1 3.737 3.738A3.741 3.741 0 0 1 12 15.738Zm1.478 1.012a.164.164 0 0 0-.174-.058A4.862 4.862 0 0 1 12 16.87a4.894 4.894 0 0 1-4.416-2.819L3.568 7.097a.164.164 0 0 0-.285.001 10.005 10.005 0 0 0 7.225 14.793.165.165 0 0 0 .166-.08l2.816-4.878a.164.164 0 0 0-.012-.182Zm2.043-8.506h5.638c.067 0 .128.042.153.104A9.951 9.951 0 0 1 22 12.001a9.937 9.937 0 0 1-2.892 7.033 9.939 9.939 0 0 1-6.995 2.965h-.001a.164.164 0 0 1-.142-.246l4.022-6.967a4.835 4.835 0 0 0 .877-2.785c0-1.317-.52-2.551-1.462-3.476a.164.164 0 0 1 .114-.28Z"
        clip-rule="evenodd"
    />
</svg>
